import {Component, EventEmitter, Output} from '@angular/core';
import {CustomMessageService, UtilService} from "library";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {ActivatedRoute} from "@angular/router";
import {Category} from "projects/store/src/app/enums";

@Component({
  selector: 'app-sales-simulator',
  templateUrl: './sales-simulator.component.html'
})
export class SalesSimulatorComponent {
  categoryCode: string;
  @Output() nextStepEvent = new EventEmitter();

  constructor(private utilService: UtilService,
              private requestService: RequestService,
              private customMessageService: CustomMessageService,
              private route: ActivatedRoute) {
    this.categoryCode = this.route.snapshot.params['category_code'];
  }

  ngOnInit() {
    this.load();
  }

  load(){
  }

  onNextStep() {
    this.nextStepEvent.emit();
  }

  protected readonly Category = Category;
}
